import { styled, Typography } from "@mui/material";

const fontStyles = {
  fontSize: "13px",
  fontFamily: "'Open Sans', sans-serif"
}

export const StyledTypography = styled(Typography)(() => (fontStyles));